<!-- This tile has a separate hover effect which is not working right now -->

<template>
    <BasicTile class="px-4 offer-wall-tile__container" @click="handleClick" v-interact>
        <div class="d-flex flex-column justify-space-between align-center h-100">
            <img :src="network.image" alt="Offer Wall" style="width: 110px;" />
            <div class="d-flex flex-column align-center">
                <span class="offer-wall-tile__title">
                    {{ getTitle() }}
                </span>
                <span class="offer-wall-tile__subtitle">
                    {{ getSubtitle() }}
                </span>
            </div>
            <div class="d-flex justify-center">
                <template v-if="network.rating === 0">
                    <span class="offer-wall-tile__new-network">NEW</span>
                </template>
                <template v-else>
                    <rating :rating="network.rating" />
                </template>
            </div>
        </div>
    </BasicTile>
</template>



<script>

import { useRouter } from 'vue-router';
import { AppConfigs } from '@/app.configs';
import Rating from "@/components/Common/Rating.vue";
import BasicTile from '@/components/Tiles/Basic-Tile.vue';
import { UserService } from "@/api/services/UserService.ts";

export default {
    name: 'OfferWallTile',
    components: {
        Rating,
        BasicTile,
    },
    props: {
        network: {
            type: Object,
            required: true
        }
    },
    setup(props, { emit }) {
        const router = useRouter();

        return {
            AppConfigs,
        }
    },
    methods: {

        getTitle() {
        if (this.network.name.toLowerCase() === 'adscendmedia') {
            return 'Adscend Media';
        } else {
        return this.$capitalize(this.network.name); 
    }
    },
        // Used for setting the subtitle based on the network type
        getSubtitle() {
            switch (this.network.name) {
                case 'adgate':
                    return 'Complete Offers & Surveys to Earn Coins';
                case 'adgem':
                    return 'Complete Offers to Earn Coins';
                case 'inbrain':
                    return 'Complete Surveys to Earn Coins';
                case 'ayetstudios':
                    return 'Complete Offers to Earn Coins';
                case 'cpxresearch':
                    return 'Complete Surveys to Earn Coins';
                case 'torox':
                    return 'Complete Offers to Earn Coins';
                case 'wannads':
                    return 'Complete Offers & Surveys to Earn Coins';
                case 'lootably':
                    return 'Complete Offers to Earn Coins';
                case 'pollfish':
                    return 'Complete Offers & Surveys to Earn Coins';
                case 'bitlabs':
                    return 'Complete Offers & Surveys to Earn Coins';
                case 'timewall':
                    return 'Complete Offers & Surveys to Earn Coins';
                default:
                    return 'Complete Tasks to Earn Coins';
            }
        },
        handleClick() {
            // warning: we might change this to google analytics in the future
            UserService.updateOfferWallClickCount({ network: this.network.name });
        }
    }
}
</script>



<style scoped lang="scss">
.tile {
    padding-top: 30px;
    padding-bottom: 20px;
    box-shadow: vars.get-map-value(vars.$tile, 'offer-wall', 'shadow');
    background-clip: padding-box;
}

.title {
    color: vars.get-map-value(vars.$tile, 'offer-wall', 'title-color');
    text-align: center;
    font-family: Montserrat;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.subtitle {
    color: vars.get-map-value(vars.$tile, 'offer-wall', 'subtitle-color');
    opacity: 0.6;
    text-align: center;
    font-family: Montserrat;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 14px;
}

.new-network {
    font-size: 10px;
    padding: 3px 5px;
    font-weight: 600;
    border-radius: 5px;
    background-color: vars.get-map-value(vars.$tile, 'offer-wall', 'new', 'background-color');
}
</style>
